import { useMutation, useQueryClient } from '@tanstack/react-query';

import { calendarApi } from '../api';

interface UseSyncOutlookCalendarsListParams {
  userId: string;
  scopes?: string[];
  accessToken?: string;
  refreshToken?: string;
  expiryDate?: string;
  rootEmail?: string;
}

export function useSyncOutlookCalendarsList() {
  const queryClient = useQueryClient();

  const syncOutlookCalendarsListMutation = useMutation({
    mutationFn: ({
      userId,
      scopes,
      accessToken,
      refreshToken,
      expiryDate,
      rootEmail,
    }: UseSyncOutlookCalendarsListParams) => {
      return calendarApi
        .syncOutlookCalendarListV2(userId, rootEmail, {
          version: 'v2.0',
          scopes,
          accessToken,
          refreshToken,
          expiryDate,
        })
        .then(({ data }) => (data ?? []) as string[]);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.calendar.meta'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.calendar.events'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.user'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.preference'] });
    },
  });

  return {
    syncOutlookCalendarsList: syncOutlookCalendarsListMutation.mutateAsync,
    ...syncOutlookCalendarsListMutation,
  };
}
